import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import {
  actionTypes,
  createConfigurationApplicationTemporaryAbilitationsMgmtFailure,
  createConfigurationApplicationTemporaryAbilitationsMgmtSuccess,
  createRoleTemporaryAbilitationConfigurationRequestFailure,
  createRoleTemporaryAbilitationConfigurationRequestSuccess,
  createTemporaryEntitlementConfigurationRequestFailure,
  createTemporaryEntitlementConfigurationRequestSuccess,
  deleteTemporaryEntitlementConfigurationRequestFailure,
  deleteTemporaryEntitlementConfigurationRequestSuccess,
  fetchEmergencyGlobalCatalogActionFailure,
  fetchEmergencyGlobalCatalogActionSuccess,
  fetchEmergencyRequiredActionFailure,
  fetchEmergencyRequiredActionSuccess,
  fetchTemporaryEntitlementsRequestFailure,
  fetchTemporaryEntitlementsRequestSuccess,
  getAutocompleteUserFailure,
  getAutocompleteUserSuccess,
  getFieldsTemporaryAbilitationConfigurationRequestFailure,
  getFieldsTemporaryAbilitationConfigurationRequestSuccess,
  getRolesTemporaryEntitlementsConfigurationRequestFailure,
  getRolesTemporaryEntitlementsConfigurationRequestSuccess,
  getTemporaryAbilitationsAlreadySetOnApplicationRequestFailure,
  getTemporaryAbilitationsAlreadySetOnApplicationRequestSuccess,
  getTemporaryEntitlementConfigurationsRequestFailure,
  getTemporaryEntitlementConfigurationsRequestSuccess,
  manageTemporaryAbilitationsInSelectedApplicationRequestFailure,
  manageTemporaryAbilitationsInSelectedApplicationRequestSuccess,
  manageTemporaryAbilitationsInSelectedApplicationRequestWarning,
  temporaryAbilitationsManagementFetchAbilitationsRequestFailure,
  temporaryAbilitationsManagementFetchAbilitationsRequestSuccess,
  temporaryAbilitationsManagementFetchApplicationsRequestFailure,
  temporaryAbilitationsManagementFetchApplicationsRequestSuccess,
  temporaryAbilitationsManagementGetSelectedApplicationConfigurationRequestFailure,
  temporaryAbilitationsManagementGetSelectedApplicationConfigurationRequestSuccess,
  updateConfigurationApplicationTemporaryAbilitationsMgmtFailure,
  updateConfigurationApplicationTemporaryAbilitationsMgmtSuccess,
  updateFieldsTemporaryAbilitationConfigurationRequestFailure,
  updateFieldsTemporaryAbilitationConfigurationRequestSuccess,
  updateTemporaryEntitlementsRequestFailure,
  updateTemporaryEntitlementsRequestSuccess,
} from "./actions";
import {
  createConfigurationApplicationTemporaryAbilitationsManagement,
  createConfigurationTemporaryAbilitation,
  createRoleTemporaryAbilitationConfigurationMgmt,
  deleteConfigurationTemporaryAbilitationConsoleAdmin,
  fetchApplicationsListTemporaryAbilitationsMgmtRequest,
  fetchEmergencyRequiredService,
  fetchGetConfigurationApplicationTemporaryAbilitationsMgmt,
  fetchGetConfigurationsTemporaryAbilitationMgmt,
  fetchGetFieldsFromSelectedTemporaryAbilitation,
  fetchGetRolesTemporaryAbilitationConfiguration,
  fetchGlobalCatalogService,
  fetchSystemUsersTemporaryAbilitation,
  fetchTemporaryAbilitationsListRequest,
  fetchTemporaryEntitlementsAlreadySetOnSelectedAbilitation,
  fetchTemporaryEntitlementsListRequestAbilitationMgmt,
  manageTemporaryAbilitationsInSelectedApplication,
  updateConfigurationApplicationTemporaryAbilitationsManagement,
  updateEmergencyConfigurationService,
  updateFieldsFromSelectedTemporaryAbilitation,
} from "./services";
import messages from "../TemporaryAbilitationsManagementStepOne/module/messages";

const fetchApplicationsListTemporaryAbilitationsMgmtRequestEpic = (
  action$: any
) =>
  action$.pipe(
    ofType(
      actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_APPLICATIONS_REQUEST
    ),
    mergeMap((action: any) =>
      fetchApplicationsListTemporaryAbilitationsMgmtRequest(
        action.payload
      ).pipe(
        map((response: any) =>
          temporaryAbilitationsManagementFetchApplicationsRequestSuccess(
            response
          )
        ),
        catchError((error: any) =>
          of(
            temporaryAbilitationsManagementFetchApplicationsRequestFailure(
              error
            )
          )
        )
      )
    )
  );

const fetchTemporaryAbilitationsListRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(
      actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_ABILITATIONS_REQUEST
    ),
    mergeMap((action: any) =>
      fetchTemporaryAbilitationsListRequest(action.payload).pipe(
        map((response: any) =>
          temporaryAbilitationsManagementFetchAbilitationsRequestSuccess(
            response
          )
        ),
        catchError((error: any) =>
          of(
            temporaryAbilitationsManagementFetchAbilitationsRequestFailure(
              error
            )
          )
        )
      )
    )
  );

const fetchTemporaryAbilitationsSelectedApplicationConfigurationRequestEpic = (
  action$: any
) =>
  action$.pipe(
    ofType(
      actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_GET_SELECTED_APPLICATION_CONFIGURATION_REQUEST
    ),
    mergeMap((action: any) =>
      fetchGetConfigurationApplicationTemporaryAbilitationsMgmt(
        action.payload
      ).pipe(
        map((response: any) =>
          temporaryAbilitationsManagementGetSelectedApplicationConfigurationRequestSuccess(
            response
          )
        ),
        catchError((error: any) =>
          of(
            temporaryAbilitationsManagementGetSelectedApplicationConfigurationRequestFailure(
              error
            )
          )
        )
      )
    )
  );

const createConfigurationApplicationTemporaryAbilitationsMgmtEpic = (
  action$: any
) =>
  action$.pipe(
    ofType(
      actionTypes.CREATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST
    ),
    mergeMap((action: any) =>
      createConfigurationApplicationTemporaryAbilitationsManagement(
        action.payload
      ).pipe(
        map((response: any) =>
          createConfigurationApplicationTemporaryAbilitationsMgmtSuccess(
            response
          )
        ),
        catchError((error: any) =>
          of(
            createConfigurationApplicationTemporaryAbilitationsMgmtFailure(
              error
            )
          )
        )
      )
    )
  );

const updateConfigurationApplicationTemporaryAbilitationsMgmtEpic = (
  action$: any
) =>
  action$.pipe(
    ofType(
      actionTypes.UPDATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST
    ),
    mergeMap((action: any) =>
      updateConfigurationApplicationTemporaryAbilitationsManagement(
        action.payload
      ).pipe(
        map((response: any) =>
          updateConfigurationApplicationTemporaryAbilitationsMgmtSuccess(
            response
          )
        ),
        catchError((error: any) =>
          of(
            updateConfigurationApplicationTemporaryAbilitationsMgmtFailure(
              error
            )
          )
        )
      )
    )
  );

const fetchGetRolesTemporaryAbilitationConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(
      actionTypes.FETCH_GET_ROLES_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST
    ),
    mergeMap((action: any) =>
      fetchGetRolesTemporaryAbilitationConfiguration().pipe(
        map((response: any) =>
          getRolesTemporaryEntitlementsConfigurationRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(getRolesTemporaryEntitlementsConfigurationRequestFailure(error))
        )
      )
    )
  );

const fetchGetConfigurationsTemporaryAbilitationMgmtEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_GET_TEMPORARY_ENTITLEMENT_CONFIGURATIONS_REQUEST),
    mergeMap((action: any) =>
      fetchGetConfigurationsTemporaryAbilitationMgmt(action.payload).pipe(
        map((response: any) =>
          getTemporaryEntitlementConfigurationsRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(getTemporaryEntitlementConfigurationsRequestFailure(error))
        )
      )
    )
  );

const createConfigurationTemporaryAbilitationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST),
    mergeMap((action: any) =>
      createConfigurationTemporaryAbilitation(action.payload).pipe(
        map((response: any) =>
          createTemporaryEntitlementConfigurationRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(createTemporaryEntitlementConfigurationRequestFailure(error))
        )
      )
    )
  );

const deleteConfigurationTemporaryAbilitationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST),
    mergeMap((action: any) =>
      deleteConfigurationTemporaryAbilitationConsoleAdmin(action.payload).pipe(
        map((response: any) =>
          deleteTemporaryEntitlementConfigurationRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(deleteTemporaryEntitlementConfigurationRequestFailure(error))
        )
      )
    )
  );

const createRoleTemporaryAbilitationConfigurationMgmtEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_ROLE_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST),
    mergeMap((action: any) =>
      createRoleTemporaryAbilitationConfigurationMgmt(action.payload).pipe(
        map((response: any) =>
          createRoleTemporaryAbilitationConfigurationRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(createRoleTemporaryAbilitationConfigurationRequestFailure(error))
        )
      )
    )
  );

const manageTemporaryAbilitationsInSelectedApplicationEpic = (action$: any) =>
  action$.pipe(
    ofType(
      actionTypes.MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST
    ),
    mergeMap((action: any) =>
      manageTemporaryAbilitationsInSelectedApplication(action.payload).pipe(
        map((response: any) => {
          const hasWarnings =
            (response.addError && response.addError.length > 0) ||
            (response.deleteError && response.deleteError.length > 0);

          const didNothing =
            response.addSuccess &&
            response.addSuccess.length === 0 &&
            response.addError &&
            response.addError.length === 0 &&
            response.deleteSuccess &&
            response.deleteSuccess.length === 0 &&
            response.deleteError &&
            response.deleteError.length === 0;

          if (hasWarnings) {
            let infoMsg = ``;
            if (response.addError.length > 0) {
              infoMsg += `Add errors: `;
              response.addError.map(
                (add: {
                  entitlementId: string;
                  entitlementName: string;
                  identitySystemId: string;
                }) => {
                  infoMsg += add.entitlementName + "; ";
                }
              );
              infoMsg = infoMsg.slice(0, -2) + ". \n";
            }
            if (response.deleteError.length > 0) {
              infoMsg += `Delete errors: `;
              response.deleteError.map(
                (del: {
                  entitlementId: string;
                  entitlementName: string;
                  identitySystemId: string;
                }) => {
                  infoMsg += del.entitlementName + "; ";
                }
              );
              infoMsg = infoMsg.slice(0, -2) + ".";
            }
            return manageTemporaryAbilitationsInSelectedApplicationRequestWarning(
              {
                ...response,
                message: infoMsg,
              }
            );
          } else if (didNothing) {
            return manageTemporaryAbilitationsInSelectedApplicationRequestSuccess(
              {
                ...response,
                message: messages.noChangesMade.id,
              }
            );
          }
          return manageTemporaryAbilitationsInSelectedApplicationRequestSuccess(
            response
          );
        }),
        catchError((error: any) =>
          of(
            manageTemporaryAbilitationsInSelectedApplicationRequestFailure(
              error
            )
          )
        )
      )
    )
  );

const fetchTemporaryEntitlementsAlreadySetOnSelectedAbilitationEpic = (
  action$: any
) =>
  action$.pipe(
    ofType(
      actionTypes.GET_TEMPORARY_ABILITATIONS_ALREADY_SET_ON_APPLICATION_REQUEST
    ),
    mergeMap((action: any) =>
      fetchTemporaryEntitlementsAlreadySetOnSelectedAbilitation().pipe(
        map((response: any) =>
          getTemporaryAbilitationsAlreadySetOnApplicationRequestSuccess(
            response
          )
        ),
        catchError((error: any) =>
          of(
            getTemporaryAbilitationsAlreadySetOnApplicationRequestFailure(error)
          )
        )
      )
    )
  );

const fetchGetFieldsFromSelectedTemporaryAbilitationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST),
    mergeMap((action: any) =>
      fetchGetFieldsFromSelectedTemporaryAbilitation(action.payload).pipe(
        map((response: any) =>
          getFieldsTemporaryAbilitationConfigurationRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(getFieldsTemporaryAbilitationConfigurationRequestFailure(error))
        )
      )
    )
  );

const updateFieldsFromSelectedTemporaryAbilitationEpic = (action$: any) =>
  action$.pipe(
    ofType(
      actionTypes.UPDATE_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST
    ),
    mergeMap((action: any) =>
      updateFieldsFromSelectedTemporaryAbilitation(action.payload).pipe(
        map((response: any) =>
          updateFieldsTemporaryAbilitationConfigurationRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(updateFieldsTemporaryAbilitationConfigurationRequestFailure(error))
        )
      )
    )
  );

const fetchTemporaryEntitlementsListRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_TEMPORARY_ENTITLEMENTS_REQUEST),
    mergeMap((action: any) =>
      fetchTemporaryEntitlementsListRequestAbilitationMgmt(action.payload).pipe(
        map((response: any) =>
          fetchTemporaryEntitlementsRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(fetchTemporaryEntitlementsRequestFailure(error))
        )
      )
    )
  );

const fetchTemporarySystemUsersRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_USER_TEMPORARY_ABILITATIONS_AUTOCOMPLETE_DIGITAL_ID),
    mergeMap(() =>
      fetchSystemUsersTemporaryAbilitation().pipe(
        map((response: any) => getAutocompleteUserSuccess(response)),
        catchError((error: any) => of(getAutocompleteUserFailure(error)))
      )
    )
  );

const fetchEmergencyGlobalCatalogEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_EMERGENCY_ENTITLEMENT_GLOBAL_CATALOG),
    mergeMap((action: any) =>
      fetchGlobalCatalogService(action.payload).pipe(
        map((response: any) =>
          fetchEmergencyGlobalCatalogActionSuccess(response)
        ),
        catchError((error: any) =>
          of(fetchEmergencyGlobalCatalogActionFailure(error))
        )
      )
    )
  );

const fetchEmergencyRequiredEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_EMERGENCY_ENTITLEMENT_REQUIRED),
    mergeMap((action: any) =>
      fetchEmergencyRequiredService(action.payload).pipe(
        map((response: any) => fetchEmergencyRequiredActionSuccess(response)),
        catchError((error: any) =>
          of(fetchEmergencyRequiredActionFailure(error))
        )
      )
    )
  );

const updateEmergencyConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_TEMPORARY_ENTITLEMENTS_REQUEST),
    mergeMap((action: any) =>
      updateEmergencyConfigurationService(action.payload).pipe(
        map((response: any) =>
          updateTemporaryEntitlementsRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(updateTemporaryEntitlementsRequestFailure(error))
        )
      )
    )
  );

export default [
  fetchApplicationsListTemporaryAbilitationsMgmtRequestEpic,
  fetchTemporaryAbilitationsListRequestEpic,
  fetchTemporaryEntitlementsListRequestEpic,
  fetchTemporaryAbilitationsSelectedApplicationConfigurationRequestEpic,
  createConfigurationApplicationTemporaryAbilitationsMgmtEpic,
  updateConfigurationApplicationTemporaryAbilitationsMgmtEpic,
  fetchGetRolesTemporaryAbilitationConfigurationEpic,
  fetchGetConfigurationsTemporaryAbilitationMgmtEpic,
  createConfigurationTemporaryAbilitationEpic,
  deleteConfigurationTemporaryAbilitationEpic,
  createRoleTemporaryAbilitationConfigurationMgmtEpic,
  manageTemporaryAbilitationsInSelectedApplicationEpic,
  fetchTemporaryEntitlementsAlreadySetOnSelectedAbilitationEpic,
  fetchGetFieldsFromSelectedTemporaryAbilitationEpic,
  updateFieldsFromSelectedTemporaryAbilitationEpic,
  fetchTemporarySystemUsersRequestEpic,
  fetchEmergencyGlobalCatalogEpic,
  fetchEmergencyRequiredEpic,
  updateEmergencyConfigurationEpic,
];
